module.exports = __webpack_public_path__ + "static/media/bio-collage.54126361.png";